import { LoginForm } from "@/components/layout/login-form";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";

export function Login() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && user) {
      // If user exists, check their state and redirect accordingly
      if (user.state === "active") {
        navigate("/app", { replace: true });
      } else if (user.state === "inactive") {
        navigate("/account-review", { replace: true });
      }
    }
  }, [user, isLoading, navigate]);

  // Show loading while checking authentication
  if (isLoading) {
    return <div />;
  }

  // Don't render login form if user is already authenticated
  if (user) {
    return <div />;
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}